'use strict';

/* eslint-disable max-lines-per-function, sort-keys */

import FormModal from 'Extensions/form-modal';
import 'jquery-validation';

export default function () {
	const formModal = new FormModal({
		trigger: document.querySelector('.ring-sizer--trigger'),
		template: document.getElementById('product-ringsizer')
	});

	var $validateForm = $(formModal.getTemplateElement());
	var $validateFormElement = $validateForm.find('#js-ringsizer-form');

	// ---- Form Validation ---- //
	$validateFormElement.validate({
		errorContainer: $validateForm.find('.validate-message'),
		errorLabelContainer: $validateForm.find('.validate-message small'),
		errorElement: 'p',
		rules: {
			ring_fname: {
				required: true,
				minlength: 2
			},
			ring_lname: {
				required: true,
				minlength: 2
			},
			ring_addr: {
				required: true,
				minlength: 2
			},
			ring_city: {
				required: true,
				minlength: 2
			},
			ring_state: {
				required: true
			},
			ring_zip: {
				required: true
			},
			ring_phone: {
				required: true
			},
			ring_email: {
				required: true,
				email: true
			}
		},
		messages: {
			ring_fname: {
				required: 'Please enter your first name.',
				minlength: jQuery.validator.format('Your Name must be a minimum of {0} characters!')
			},
			ring_lname: {
				required: 'Please enter your last name.',
				minlength: jQuery.validator.format('Your Name must be a minimum of {0} characters!')
			},
			ring_addr: {
				required: 'Please enter your address.',
				minlength: jQuery.validator.format('Your Name must be a minimum of {0} characters!')
			},
			ring_city: {
				required: 'Please enter your city.',
				minlength: jQuery.validator.format('Your Name must be a minimum of {0} characters!')
			},
			ring_state: {
				required: 'Please select a state.',
				minlength: jQuery.validator.format('Your Name must be a minimum of {0} characters!')
			},
			ring_zip: {
				required: 'Please enter your zip code.'
			},
			ring_phone: {
				required: 'Please enter your phone number.'
			},
			ring_email: {
				required: 'Please enter your email address.',
				email: 'Your Email Address must be formatted like name@domain.com'
			}
		},
		highlight: function (element, errorClass) {
			$(element.form).find('label[for=' + element.id + ']').addClass(errorClass);
		},
		unhighlight: function (element, errorClass) {
			$(element.form).find('label[for=' + element.id + ']').removeClass(errorClass);
		},
		submitHandler: function (form, event) {
			event.preventDefault();

			if ($(this).data('formstatus') !== 'submitting') {
				var form = $validateFormElement,
					formData = form.serializeArray(),
					formUrl = form.attr('action'),
					formMethod = form.attr('method');

				formData.push({
					name: 'ajax',
					value: 1
				});

				form.data('formstatus', 'submitting');

				$.ajax({
					url: formUrl,
					type: formMethod,
					data: $.param(formData),
					success: function (data) {
						var formattedHTML = '',
							validForm = 0;

						$.each(data, function (key, value) {
							var status = value.status,
								message = value.message;

							if (status == 200) {
								// Success
								formattedHTML += '<p class="message message-info">' + message + '</p>';
								form.hide();

								validForm = 1;
							} else {
								// Error
								formattedHTML += '<p class="message message-error">' + message + '</p>';
							}
						});

						$validateForm.find('.response-message').html(formattedHTML).fadeIn(200);

						if (validForm === 1) {
							$.each(form.find('input, select'), function (i) {
								if ($(this).attr('type') !== 'submit') {
									$(this).val('');
								}
							});
						}

						form.data('status', 'idle');
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log(errorThrown);
						form.data('formstatus', 'idle');
					}
				});
			}
		}
	});
};
